import { render, staticRenderFns } from "./OrganizationSettingsWaiver.vue?vue&type=template&id=00836561&scoped=true"
import script from "./OrganizationSettingsWaiver.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsWaiver.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsWaiver.vue?vue&type=style&index=0&id=00836561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00836561",
  null
  
)

export default component.exports